import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  EventEmitter,
  Input,
  Output,
  QueryList,
} from '@angular/core';
import { GasTemplateDirective } from '../../utils/gas-template/gas-template.directive';

export type DatatableValue<T = unknown> = Record<string, T>;

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'table[gasDatatable]',
  templateUrl: './gas-datatable.component.html',
  styleUrls: ['./gas-datatable.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasDatatableComponent implements AfterContentInit {

  @ContentChildren(GasTemplateDirective)
  public gasTemplates: QueryList<GasTemplateDirective>;

  @Input()
  public loading = false;

  @Input()
  public error = false;

  @Input()
  public isValueEmpty: boolean;

  @Input('gasDatatable')
  public data: DatatableValue[]= [];

  @Output('onRowClick')
  public onRowClick$ = new EventEmitter<any>();

  public headerTemplate;

  public bodyTemplate;

  public rowClick(rowData: DatatableValue): void {
    this.onRowClick$.emit(rowData);
  }

  public ngAfterContentInit(): void {
    this.gasTemplates.forEach((gasTemplate: GasTemplateDirective) => {
      switch (gasTemplate.name) {
        case 'header':
          this.headerTemplate = gasTemplate.template;
          break;

        case 'body':
          this.bodyTemplate = gasTemplate.template;
          break;
      }
    });
  }

}
